import React, { useEffect } from "react";
import { Formik } from "formik";
import { default_server } from './../../../services/api';
import * as yup from "yup";
import InputMask from "react-input-mask";
import preLoader from "../../../assets/images/preloader_button.gif";
import success from "../../../assets/images/success.png";
import "./faleconosco-form.css";
import Button from "../../button";
import toast from "react-hot-toast";
import { PRODUCT } from "../../../consts/product";

const validationSchema = yup.object().shape({
  name: yup.string().required("Digite seu nome"),
  email: yup
    .string()
    .matches(
      /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/,
      "E-mail não válido"
    )
    .required("Digite seu e-mail"),
  msisdn: yup.string().required("Digite seu celular"),
  message: yup.string().required("Digite sua mensagem")
})

const Form = props => {
  const {
    toggle_callus,
    isLoading,
    isSuccess,
    setIsSuccess,
  } = props;
  

  useEffect(() => {
    return () => {
      setIsSuccess(false);
    };
  }, [setIsSuccess]);

  const SEND = isLoading ? (
    <img src={preLoader} alt={"Loading..."} style={{ height: "25px" }} />
  ) : isSuccess ? (
    <img src={success} alt={"Success"} style={{ height: "25px" }} />
  ) : (
    "ENVIAR"
  );

  return (
    <Formik
      initialValues={{
        name: "",
        email: "",
        msisdn: "",
        message: ""
      }}
      validationSchema={validationSchema}
      onSubmit={(values, { setSubmitting }) => {
        const {
          name,
          email,
          msisdn,
          message
        } = values;
    
        props.setIsLoading(true);
    
        const axios = require('axios');
        axios.post(`${default_server}/email`, {
          "msisdn": `55${msisdn.replace(/[^a-zA-Z0-9]/g, "")}`,
          "email": email,
          "mensagem": message,
          "nome": name,
          "produto": PRODUCT,
          "app":"1" // adicionado especialmente para o dum dum a pedido da N3R
        })
        .then(function (response) {
          
          if ('data' in response) {
            if ('returncode' in response.data) {
              if (response.data.returncode === '200') {
                setTimeout(() => {
                  props.setIsLoading(false);
                  props.setIsSuccess(true);
                  setSubmitting(false);

                  toast.success("Mensagem enviada! Vamos respondê-la o mais rápido possível!", {
                    duration: 2000
                  })
                }, 1000);
                setTimeout(() => {
                  props.toggle_callus(false);
                }, 2500);
              }
              else {
                throw `Error ${response.data.returncode}`
              }
            }
            else {
              throw 'missing "returncode" object'
            }
          }
          else {
            throw 'missing "data" object'
          }
    
        })
        .catch(error => {
          setTimeout(() => {
            props.setIsLoading(false);
            props.setIsSuccess(false);
          }, 600);
        });
      }}
    >
      {({
        touched,
        errors,
        isSubmitting,
        values,
        handleSubmit,
        handleChange
      }) => (
        <form className="w-full flex flex-col items-center justify-center text-sm" onSubmit={handleSubmit}>
          <div className="w-full space-y-4 fale_conosco_container">
            <div className="w-full">
              <input
                name="name"
                className="bg-gray-50 border border-gray-primary text-sm rounded-lg block w-full p-2.5"
                placeholder="Nome"
                type="text"
                value={values.name}
                onChange={handleChange("name")}
              />
              {errors.name && touched.name ? (
                <span className="font-base text-red-600">{errors.name}</span>
              ) : null}
            </div>

            <div className="w-full">
              <input
                className="bg-gray-50 border border-gray-primary text-sm rounded-lg block w-full p-2.5"
                placeholder="E-mail"
                type="text"
                value={values.email}
                onChange={handleChange("email")}
                name="email"
              />
              {errors.email && touched.email ? (
                <span className="font-base text-red-600">{errors.email}</span>
              ) : null}
            </div>
            
            <div className="w-full">
              <InputMask
                className="bg-gray-50 border border-gray-primary text-sm rounded-lg block w-full p-2.5"
                type="tel"
                name="msisdn"
                mask="(99) 99999-9999"
                placeholder="Número do celular com DDD"
                maskChar={null}
                value={values.msisdn}
                onChange={handleChange("msisdn")}
              />
              {errors.msisdn && touched.msisdn ? (
                <span className="font-base text-red-600">{errors.msisdn}</span>
              ) : null}
            </div>

            <div className="w-full">
              <textarea
                className="h-36 resize-none bg-gray-50 border border-gray-primary text-sm rounded-lg block w-full p-2.5"
                type="text"
                value={values.message}
                onChange={handleChange("message")}
                placeholder="Mensagem"
              />
              {errors.message && touched.message ? (
                <span className="font-base text-red-600">{errors.message}</span>
              ) : null}
            </div>
          </div>

          <Button type="submit" disabled={isSubmitting}>
            Enviar
          </Button>
        </form>
      )}
    </Formik>
  );
};

export default Form;
